<!-- MODULO BANNER -->
<div class="container-fluid cta no-print" *ngIf="!(isMobile && isHomepage)">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-8 mb-4 mb-md-0">
        <h5 class="text-white">
          {{'TESTO_BANNER_CONFIGURATORE' | translate | htmlToText}}
        </h5>
      </div>
      <div class="col-12 col-md-4 text-center text-md-right">
        <a appHref="/configuratore">
          <button class="btn btn-stem mx-auto" type="button">
            {{'CONFIGURA_IL_TUO_PRODOTTO' | translate | htmlToText}}
          </button>
        </a>
      </div>
    </div>
  </div>
</div>

